import { useState } from "react"
import "../App.css"

export function Projects() {
    const [play1, setPlay1] = useState(false);
    const [play2, setPlay2] = useState(false);
    const [play3, setPlay3] = useState(false);
    const [play4, setPlay4] = useState(false);

    return <div className="Projects" id="projects">
        <h1>Projects</h1>
        <div>
            <div className="proj" onMouseEnter={() => setPlay1(true)} onMouseLeave={() => setPlay1(false)}>
                <div><img style={!play1 ? { display: "block" } : { display: "none" }} src="yatra.png" alt="missa" /><img style={!play1 ? { display: "none" } : { display: "block" }} src="yatragif.gif" alt="missa" /></div>
                <div>
                    <h2>Clone Yatra</h2>
                    <p>This is a clone of Yatra.com website. Added functionalities of comparing prices and book a wide range of flights according to the travel needs.</p>
                    <div><strong>Tech-Stack: </strong>Html | CSS | JavaScript | Express Js | MongoDB | React</div>
                    <div id="buttons">
                        <a href="https://yatraclone.herokuapp.com/" target="_blank" rel="noreferrer">Demo</a>
                        <a href="https://github.com/Balkishan-Pal/Yatra" target="_blank" rel="noreferrer">Github</a>
                    </div>
                </div>
            </div>
            <div className="proj" onMouseEnter={() => setPlay2(true)} onMouseLeave={() => setPlay2(false)}>
                <div><img style={!play2 ? { display: "block" } : { display: "none" }} src="udacity.png" alt="udacity" /><img style={!play2 ? { display: "none" } : { display: "block" }} src="udacitygif.gif" alt="udacity" /></div>
                <div>
                    <h2>Clone Udacity</h2>
                    <p>This is a clone of Udacity app which helps in booking courses. Includes functionalities of booking online courses and previewing them.</p>
                    <div><strong>Tech-Stack: </strong>Html | CSS | JavaScript | Express Js | MongoDB</div>
                    <div id="buttons">
                        <a href="https://udacity-clone-git-master-udacity-clone.vercel.app/" target="_blank" rel="noreferrer">Demo</a>
                        <a href="https://github.com/Pavankalyan477/Udacity_Project" target="_blank" rel="noreferrer">Github</a>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div className="proj" onMouseEnter={() => setPlay3(true)} onMouseLeave={() => setPlay3(false)}>
                <div><img style={!play3 ? { display: "block" } : { display: "none" }} src="missa.png" alt="missa" /><img style={!play3 ? { display: "none" } : { display: "block" }} src="missagif.gif" alt="missa" /></div>
                <div>
                    <h2>Clone MissA</h2>
                    <p>This project is a clone of the facial products selling website, shopMissA. Added the functionalities to login/signup and complete order procedure.</p>
                    <div><strong>Tech-Stack: </strong>Html | CSS | JavaScript </div>
                    <div id="buttons">
                        <a href="https://miss-a-project.netlify.app" target="_blank" rel="noreferrer">Demo</a>
                        <a href="https://github.com/rv-vikram/MissA_Project" target="_blank" rel="noreferrer">Github</a>
                    </div>
                </div>
            </div>
            <div className="proj" onMouseEnter={() => setPlay4(true)} onMouseLeave={() => setPlay4(false)}>
                <div><img style={!play4 ? { display: "block" } : { display: "none" }} src="zoom.png" alt="zoom" /><img style={!play4 ? { display: "none" } : { display: "block" }} src="zoomgif.gif" alt="zoom" /></div>

                <div>
                    <h2>Clone ZoomCar</h2>
                    <p>We built the UI clone of Zoomcar.com, a self-drive car rental application. This project enables the user to choose booking details.</p>
                    <div><strong>Tech-Stack: </strong>Html | CSS | JavaScript</div>
                    <div id="buttons">
                        <a href="https://zoomcarclone.netlify.app/" target="_blank" rel="noreferrer">Demo</a>
                        <a href="https://github.com/Jagadish1217/ZoomCar-Proj" target="_blank" rel="noreferrer">Github</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
}